import { makeStyles } from '@mui/styles';

const useStyles = makeStyles(() => ({
  TableContainer: {
    background: '#F9FAFB',
    border: '1px solid #EAECF0',
    borderRadius: '12px',
    height: 'calc(100dvh - 120px)',
    overflow: 'auto',
    flex: 1,
    boxShadow: '0 1px 3px 0 rgba(16, 24, 40, 0.10), 0 1px 2px 0 rgba(16, 24, 40, 0.06)',
  },
}));

export { useStyles };
